import axiosInstance from "../axiosInterceptor";

export async function getCourseByUniversitySlug(page = 1, slug) {

    const response = await axiosInstance.post(`admin/course/getCourseByUniversitySlug/${slug}`,
        {
            perPage: 7,
            pageNo: page,
        });
    const data = response?.data;
    return data;
}